<template>
  <div class="row">
     
    <div class="col-12">
      <code v-if="debug">
        {{ data }}
        <hr />
        {{ model }}
      </code>
      <div>
        <b-form-group label="Kiosk Name" :disabled="true">
          <b-form-input v-model="model.Name"></b-form-input>
        </b-form-group>
      </div>
      <div>
        <b-form-group label="Kiosk Enabled" :disabled="false">
          <div class="toggleWrapper">
            <input id="dn" v-model="enabledState" class="dn" type="checkbox" />
            <label class="toggle" for="dn"
              ><span class="toggle__handler"></span
            ></label>
          </div>
        </b-form-group>
      </div>
    </div>
    <hr />
    <div class="col-12 bt-1">
        <b-button variant="success" class="mr-1" @click="save" >Save</b-button>
         <b-button variant="success" @click="saveAndClose">Save &amp; Close</b-button>
         <b-button variant="secondary" class="ml-1" @click="cancel">Cancel</b-button>
    </div>
  </div>
</template>

<script>
import NotificationMixin from '@mixins/notificationMixin.js';
import CancelMixin from '@mixins/cancel.js'
export default {
    mixins: [NotificationMixin, CancelMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    contentType: {
        type: Object,
        required: true
    }
  },
  data() {
    return {
    debug: false,   
    enabledState: null,
      model: {
        Name: null,
        Enabled: null,
      },
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
          if(data) this.mapData(data)
      },
    },
    enabledState(enabled) {
        this.model.Enabled = enabled ? 'T' : 'F'
    }
  },
  methods: {
    mapData(dataIn) {
      //   Take the server data and apply it to our model
      this.model.Name = dataIn.KioskName
      this.model.Enabled = dataIn.KioskEnabled
      this.enabledState = dataIn.KioskEnabled === 'T';
    },
    async save() {
      if (this.saveDisabled) {
        return;
      }
      const type = 'patch';
      try {
        await this.$store.dispatch(`${this.contentType.name}/${type}`, {
          id: this.data[this.contentType.idKey],
          body: this.model
        });
        this.showNotification("Saved successfully", "success");
      } catch (error) {
        this.showNotification(error, "error");

        throw new Error(error);
      }
    },
    async saveAndClose() {
      if (this.saveDisabled) {
        return;
      }
      try {
        await this.save();
      } catch (error) {
        window.console.log(error);
        return;
      }
      this.$router.push(`/${this.contentType.name}/list`);
    },
  },
}
</script>
